import { z } from "@zod/mini";

const UserIdSchema = z.string().check(z.minLength(1), z.trim());
const UserEmailSchema = z.email();
const UserMetadataSchema = z.record(z.string(), z.union([z.string(), z.number(), z.boolean()]));

export type UserIdentificationData = {
  userId: string;
  userEmail: string;
  userMetadata: Record<string, string | number | boolean>;
};

let currentUserIdentification: UserIdentificationData | null = null;

export function identify(userId: unknown, userEmail: unknown, userMetadata: unknown): void {
  const userIdResult = UserIdSchema.safeParse(userId);
  if (!userIdResult.success) {
    console.warn("Dewey::Search failed to identify user — id must be a non-empty string");
    return;
  }

  const userEmailResult = UserEmailSchema.safeParse(userEmail);
  if (!userEmailResult.success) {
    console.warn("Dewey::Search failed to identify user – you must provide a valid email");
    return;
  }

  const userMetadataResult = UserMetadataSchema.safeParse(userMetadata);
  if (!userMetadataResult.success) {
    console.warn("Dewey::Search failed to identify user — metadata must have string keys and primitive values");
    return;
  }

  if (import.meta.env.DEV) {
    console.log("User identified:");
    console.log(` ↳ ${userIdResult.data.trim()}`);
    console.log(` ↳ ${userEmailResult.data.trim()}`);
    console.log(` ↳ ${JSON.stringify(userMetadataResult)}`);
  }

  currentUserIdentification = {
    userId: userIdResult.data.trim(),
    userEmail: userEmailResult.data.trim(),
    userMetadata: userMetadataResult.data,
  };
}

export function getUserId(): string | undefined {
  return currentUserIdentification?.userId;
}

export function getUserEmail(): string | undefined {
  return currentUserIdentification?.userEmail;
}

export function getUserMetadata(): Record<string, unknown> | undefined {
  return currentUserIdentification?.userMetadata;
}
